import { Link } from "@/lib/router-compat";
import { Button } from "@/components/ui/button";
import { Menu } from "lucide-react";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import DatePickerDialog from "@/components/DatePickerDialog";
import starIcon from "@/assets/star-icon.svg";

const Navigation = () => {
  const links = [
    { href: "/tiempos-nica-hoy", label: "🇳🇮 Tiempos Nica" },
    { href: "/tiempos-tica-hoy", label: "🇨🇷 Tiempos Tica" },
    { href: "/articulos", label: "Artículos" },
    { href: "/numero-suerte", label: "Tu suerte" },
  ];

  return (
    <nav className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container mx-auto px-4">
        <div className="grid h-16 grid-cols-[minmax(0,1fr)_auto] items-center gap-2 xl:flex xl:justify-between">
          {/* Logo */}
          <Link to="/" className="flex min-w-0 items-center gap-1 sm:gap-2">
            <img src={starIcon} alt="Star" width={24} height={24} className="h-5 w-5 shrink-0 sm:h-6 sm:w-6" style={{ filter: 'brightness(0) saturate(100%) invert(20%) sepia(98%) saturate(1869%) hue-rotate(186deg) brightness(95%) contrast(101%)' }} />
            <div className="text-sm sm:text-xl font-bold whitespace-nowrap">
              <span style={{ color: '#004875' }}>Tiempos</span>
              <span style={{ color: '#ff6200' }}>Hoy</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden xl:flex items-center gap-1">
            {links.map((link) => (
              <Button key={link.href} asChild variant="ghost">
                <Link to={link.href}>{link.label}</Link>
              </Button>
            ))}
            <DatePickerDialog navigation />
            <Button asChild className="ml-2 shrink-0 font-bold">
              <a href="https://play.tiemposhoy.com">Juega Gratis</a>
            </Button>
          </div>

          {/* Mobile Navigation */}
          <div className="flex shrink-0 items-center gap-1 xl:hidden">
            <Button asChild className="shrink-0 px-3 font-bold">
              <a href="https://play.tiemposhoy.com">Juega Gratis</a>
            </Button>
          <Sheet>
            <SheetTrigger asChild>
              <Button variant="ghost" size="icon" aria-label="Abrir menú">
                <Menu className="h-6 w-6" aria-hidden="true" />
              </Button>
            </SheetTrigger>
            <SheetContent>
            <SheetHeader>
              <SheetTitle className="flex items-center gap-2">
                <img src={starIcon} alt="Star" width={20} height={20} className="h-5 w-5" style={{ filter: 'brightness(0) saturate(100%) invert(20%) sepia(98%) saturate(1869%) hue-rotate(186deg) brightness(95%) contrast(101%)' }} />
                <span style={{ color: '#004875' }}>Tiempos</span>
                <span style={{ color: '#ff6200' }}>Hoy</span>
              </SheetTitle>
            </SheetHeader>
              <div className="flex flex-col space-y-4 mt-8">
                {links.map((link) => (
                  <Button key={link.href} asChild variant="ghost" className="justify-start text-lg">
                    <Link to={link.href}>{link.label}</Link>
                  </Button>
                ))}
                <DatePickerDialog mobile />
              </div>
            </SheetContent>
          </Sheet>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
